import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-item-incentive-bonuses',
    name: 'pay-item-incentive-bonus',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-item-incentive-bonus')
  }
]
